import React from 'react';
import CustomCard from '../../../../../../../components/CustomCard';
import CustomTooltip from '../../../../../../../components/CustomTooltip';
import { CustomCheckbox } from '../../../../../../../components/CustomCheckbox';
import {
    NumericFieldChip,
    PlusIconsOptions,
    IconCloseChip, IconGraphDown
} from '../../../../../../../components/buttons/IconButtons';
import {getCalculationTypeById} from "../../../OvertimePolicies/Global/CreateUpdatePolicy/Model/Model";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * @Description Card for global deduction policy items used in StepGlobalRules.
 * Available mode: pass onAdd — shows PlusIconsOptions.
 * Selected mode: pass onDelete — shows IconCloseChip.
 * Assigned mode: pass handleCheckboxChange + keyId — shows CustomCheckbox.
 */
const DeductionPolicyCard = ({ item, onAdd, onDelete, keyId, handleCheckboxChange }) => {
    const calcType = getCalculationTypeById(item?.calculationType);
    const buttonActions = (onAdd || onDelete);

    return (
        <CustomCard
            classes="w-100"
            classCard="card-border-8px"
            classContent={`background-shades-100 ${item?.disabled ? 'disable-card-item' : 'background-hover-shades-100'}`}
        >
            <div className="d-flex align-items-center">
                {handleCheckboxChange &&
                    <div className="align-top mr-3">
                        <CustomCheckbox
                            id={`cb_dp_row_${item?.[keyId]}`}
                            checked={item?.checked}
                            onChange={(e) => handleCheckboxChange({
                                target: {
                                    [keyId]: item[keyId],
                                    checked: e.target.checked,
                                },
                            })}
                            disabled={item?.disabled}
                        />
                    </div>
                }

                <div className={`flex-grow-1 minw-0 ${buttonActions ? 'mr-2' : ''}`}>
                    <div className="d-flex align-items-center">
                        <div><IconGraphDown className="mr-8px mb-1" /></div>
                        <div className="flex-grow-1 minw-0">
                            <CustomTooltip
                                text={item?.name}
                                classes="fs-14px font-color-general-950 ibl-font-w-600 text-ellipsis-1-row"
                                showIfTruncated={true}
                            />
                        </div>
                    </div>

                    <div className="border-bottom-shades-300 my-2" />

                    <div className="d-flex align-items-center">
                        <div><NumericFieldChip className="mr-8px mb-1" /></div>
                        <div className="flex-grow-1 minw-0">
                            <CustomTooltip
                                text={`-${calcType?.prefixText}${item?.value}`}
                                classes="fs-13px font-color-general-950 text-ellipsis-1-row"
                                showIfTruncated={true}
                            />
                        </div>
                    </div>
                </div>

                {buttonActions &&
                    <div className="d-flex justify-content-end">
                        {onAdd && (
                            <PlusIconsOptions
                                className="plus-icons-options icon-color-shades-400"
                                onClick={() => onAdd(item)}
                            />
                        )}
                        {onDelete && (
                            <IconCloseChip
                                className="icon-color-shades-400 icon-hover-shades-950"
                                onClick={() => onDelete(item)}
                            />
                        )}
                    </div>
                }
            </div>
        </CustomCard>
    );
};

export default DeductionPolicyCard;
